import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import * as _ from 'underscore';

type UseRoleProps = {
  module: string;
  controller: string;
  type: string | undefined;
  action?: Array<string> | undefined;
  contract_id?: undefined;
  value?: undefined;
};

type Obj = {
  [propName: string]: any;
};

type ObjArray = Array<Obj>;

const useRole = ({ action, module, controller, contract_id, type, value }: UseRoleProps) => {
  const selectedData = useSelector((state: Obj) => {
    if (type == 'merchant') {
      return (state && state?.merchant?.role_list) || [];
    } else {
      return (state && state?.merchant?.me?.role_list) || [];
    }
  });
  const role_list = selectedData;
  // console.log('selectedData :', selectedData);

  const _action: Array<string> = action || ['get', 'get_list', 'delete', 'update', 'add'];

  const role = useMemo(() => {
    const roleChecker = _action.map((_a) => ({
      action: _a,
      //contract_id: contract_id || null,
      ctrl: controller,
      module: module,
      type: type && type.toUpperCase()
      //value: value || null
    }));

    const actionRole = roleChecker.filter(
      (role) => (role_list || []).filter((_role: ObjArray) => _.isEqual(_role, role)).length > 0
    );

    return _action.reduce((acc: Obj, cur) => {
      acc[cur] = actionRole.filter((role) => role.action === cur).length > 0;
      return acc;
    }, {});
  }, [action, module, controller, contract_id, type, value, role_list]);

  // console.log('useRole :', role);

  // Return the role and a dummy function to setRole (which does nothing) for previously used functionality
  return [role, () => {}];
};

export default useRole;
